import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent($options.effectiveTag), _mergeProps({
    class: $options.classes,
    type: $options.effectiveType,
    disabled: $options.isNativeButton && !$props.enabled,
    to: $props.to,
    role: $options.effectiveRole,
    tabindex: $options.effectiveTabIndex,
    "aria-disabled": $options.effectiveAriaDisabled,
    "aria-label": $props.ariaLabel
  }, _ctx.$attrs, {
    onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('click', $event)))
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["class", "type", "disabled", "to", "role", "tabindex", "aria-disabled", "aria-label"]))
}